<script lang="ts">
	import { isCustomQuestionRequired } from '$lib/domain/customQuestions/customQuestions'
	import { Checkbox } from '@repo/ui'
	import { Input } from '@repo/ui'
	import { Select } from '@repo/ui'
	import {
		EnumsV1AnswerType,
		type TypesV1CustomQuestionAnswerAnswer,
		type TypesV1CustomQuestionSettings,
	} from '@sdk/Api'

	interface Props {
		index: number
		question: TypesV1CustomQuestionSettings
		answer: TypesV1CustomQuestionAnswerAnswer
	}

	let { index, question, answer = $bindable() }: Props = $props()
</script>

{#if question.basicQuestion}
	{#if question.basicQuestion.answerType === EnumsV1AnswerType.ANSWER_TYPE_TEXT}
		<Input
			name="custom-question-{index}"
			label={question.question}
			required={isCustomQuestionRequired(question.visibility)}
			bind:value={answer.text}
		/>
	{:else if question.basicQuestion.answerType === EnumsV1AnswerType.ANSWER_TYPE_CHECKBOX}
		<div>
			<Checkbox
				name="custom-question-{index}"
				label={question.question}
				required={isCustomQuestionRequired(question.visibility)}
				showAsterisk
				small
				bind:checked={answer.checkbox}
			/>
		</div>
	{/if}
{:else if question.selectOptionQuestion}
	<Select
		name="custom-question-{index}"
		label={question.question}
		multiple={question.selectOptionQuestion.selectMultiple}
		options={question.selectOptionQuestion.options.map((option) => ({
			label: option,
			value: option,
		}))}
		required={isCustomQuestionRequired(question.visibility)}
		showAllPlaceholder={false}
		bind:values={answer.options.values}
	/>
{/if}
